import React, { Component } from 'react';
import { Container, Row, Col, FormGroup, Modal, ModalBody, ModalFooter } from 'reactstrap';
import logo from '../images/logo.png';
import phone from '../images/phone.png';
import { NavMenu } from './NavMenu';
import menu from '../images/menu.png';

function MainMenu({toggleModal}) {
	return (
		<React.Fragment>
			<Row>
				<Col xs={6} sm={5} md={4}>
					<a className='logo-link' href='/'>
						<img className='logo' src={logo} alt="Логотип"/>
					</a>
				</Col>
				<Col md={8} className='navigation-bar-desktop'>
						<div>г. Ярославль</div>
						<div>ул. Академика Колмогорова, д.22</div>
						<div>тел:&nbsp;
							<strong>
							<a href='tel:+79012733515'>+7-901-273-35-15</a>,&nbsp;
							<a href='tel:+79397767402'>+7-939-776-74-02</a>
							</strong>
						</div>
				</Col>
				<Col>
					<div className='navigation-bar-mobile'>
						<button className='btn-icon' type='button' onClick={toggleModal}>
							<img alt='меню' className='toolbar-logo' src={menu} height='27' width='27' />
						</button>
					</div>
				</Col>
			</Row>
			<NavMenu />
		</React.Fragment>
	);
}

function Footer() {
	const nowYear = (new Date()).getFullYear()

	return (
		<div className='footer-container'>
			<FormGroup className='footer-block'>
				<img alt='логотип' className='footer-block-logo' src={logo} height={55} />
			</FormGroup>
			<FormGroup className='footer-block'>
				<div className='footer-options-block'>
					<a className='footer-btn' href='/'>Главная</a>
					<a className='footer-btn' href='/catalog'>Каталог</a>
					<a className='footer-btn' href='/works'>Наши работы</a>
				</div>
				<div className='footer-options-block'>
					<a className='footer-btn' href='/comments'>Отзывы</a>
					<a className='footer-btn' href='/about'>О компании</a>
					<a className='footer-btn' href='/contacts'>Контакты</a>
				</div>
				<div className='footer-contacts-block'>
					<img width={32} height={32} loading='lazy' src={phone} alt='телеофн'/>
					<div>
						<a href='tel:+79012733515' className='footer-contacts-value'>+7-901-273-35-15</a>
						<a href='tel:+79397767402' className='footer-contacts-value'>+7-939-776-74-02</a>
					</div>
				</div>
			</FormGroup>
			<div className='copiright-line'>
				<hr />
				<span>Copyright © 2020 – {nowYear}</span>
			</div>
		</div>
	)
}

export class Layout extends Component {
	displayName = Layout.name

	constructor(props) {
		super(props);

		this.toggleModal = this.toggleModal.bind(this);
		this.state = {
			collapsed: false,
			modal: false
		};
	}

	toggleModal() {
		this.setState({
			modal: !this.state.modal
		});
	}

	render() {
		return (
			<Container className='main-container'>
				<div className='header'>
					<MainMenu toggleModal={this.toggleModal} />
				</div>
				<div className='spacer'></div>
				<Row>
					<Col>
						{this.props.children}
					</Col>
				</Row>
				<hr/>
				<Footer />

				<Modal isOpen={this.state.modal} toggle={this.toggleModal} className='navigation-modal-block'>
					<ModalBody>
						<button className='modal-close btn-icon' onClick={this.toggleModal}></button>
						<FormGroup>
							<img width={240} src={logo} alt="Логотип" />
						</FormGroup>
						<a className='navigation-modal-link' href='/'>
							<span className='nav-item'>Главная</span>
						</a>
						<a className='navigation-modal-link' href='/catalog'>
							<span className='nav-item'>Каталог</span>
						</a>
						<a className='navigation-modal-link' href='/works'>
							<span className='nav-item'>Наши работы</span>
						</a>
						<a className='navigation-modal-link' href='/comments'>
							<span className='nav-item'>Отзывы</span>
						</a>
						<a className='navigation-modal-link' href='/about'>
							<span className='nav-item'>О компании</span>
						</a>
						<a className='navigation-modal-link' href='/contacts'>
							<span className='nav-item'>Контакты</span>
						</a>
					</ModalBody>
					<ModalFooter>
						<div className='address-block'>
							<div>г. Ярославль</div>
							<div>ул. Академика Колмогорова, д.22</div>
						</div>
						<div className='phone-block'>
							<img width={32} height={32} loading='lazy' src={phone} alt='телеофн' />
							<div>
								<a href='tel:+79012733515' className='modal-phone-footer'>+7-901-273-35-15</a>
								<a href='tel:+79397767402' className='modal-phone-footer'>+7-939-776-74-02</a>
							</div>
						</div>

					</ModalFooter>
				</Modal>
			</Container>
		);
	}
}
